var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_8659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 1.61612L30.3839 0L0 30.3839L1.61612 32L3.90182 29.7143H27.4286C28.0345 29.7135 28.6154 29.4724 29.0439 29.0439C29.4724 28.6154 29.7135 28.0345 29.7143 27.4286V3.90182L32 1.61612ZM27.4286 27.4286H6.18755L15.0937 18.5223L17.8124 21.2408C18.241 21.6694 18.8224 21.9102 19.4286 21.9102C20.0348 21.9102 20.6162 21.6694 21.0448 21.2408L22.8572 19.4286L27.4286 23.9969V27.4286ZM27.4286 20.7636L24.4734 17.8084C24.0447 17.3797 23.4634 17.1389 22.8572 17.1389C22.2509 17.1389 21.6696 17.3797 21.2409 17.8084L19.4286 19.6208L16.712 16.9041L27.4286 6.18755V20.7636Z",
    fill: "#727190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5647 22.9105V19.4707L10.2978 13.7415L11.8724 15.3162L13.4959 13.6926L11.9193 12.116C11.4892 11.6859 10.906 11.4443 10.2978 11.4443C9.6896 11.4443 9.1063 11.6859 8.67626 12.116L4.5647 16.2276V4.5647H22.9105V2.27148H4.5647C3.9567 2.27209 3.37376 2.51389 2.94382 2.94382C2.51389 3.37376 2.27209 3.9567 2.27148 4.5647V22.9105H4.5647Z",
    fill: "#727190"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_8659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.3b79e5e07cd4bfe7063a3f55345a8cfa.svg";
export { ForwardRef as ReactComponent };